/* ZFF buyer inquiry measurement. Existing Shopify Google channel owns GA4 config. */
(function () {
  'use strict';
  if (window.__zffBuyerMeasurement) return;
  window.__zffBuyerMeasurement = true;
  var pixelId = 'C4SZ857L4Lw2ZGtgTV33AQ';
  var gaId = 'G-WHG1LBTB9W';
  var pendingKey = 'zff_buyer_pending_v1';
  var attributionKey = 'zff_buyer_attribution_v1';
  var pixelLoaded = false;
  var pageSent = false;
  var receipt = null;
  var gaSent = false;
  var adSent = false;
  var pagePath = window.location.pathname;
  var isBuyerPage = /^\/pages\/(wholesale-pasta-salad-supplier|private-label-pasta-salad-manufacturer)\/?$/.test(pagePath);
  var program = pagePath.indexOf('private-label') !== -1 ? 'private_label' : 'wholesale';
  var attribution = {};
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function write(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; } }
  function privacy() { return window.Shopify && window.Shopify.customerPrivacy; }
  function gpc() { return navigator.globalPrivacyControl === true; }
  function analyticsAllowed() { var p = privacy(); return !gpc() && p && typeof p.analyticsProcessingAllowed === 'function' && p.analyticsProcessingAllowed(); }
  function adsAllowed() { var p = privacy(); return !gpc() && p && typeof p.marketingAllowed === 'function' && p.marketingAllowed() && typeof p.saleOfDataAllowed === 'function' && p.saleOfDataAllowed(); }
  function loadPixel() {
    if (pixelLoaded || !adsAllowed()) return;
    pixelLoaded = true;
    if (!window.oaiq) {
      var q = function () { q.q.push(arguments); }; q.q = []; window.oaiq = q;
      var script = document.createElement('script'); script.async = true;
      script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js'; document.head.appendChild(script);
    }
    window.oaiq('consent', true);
    window.oaiq('init', { pixelId: pixelId });
  }
  function updateAttribution() {
    if (!analyticsAllowed()) return;
    var query = new URLSearchParams(window.location.search);
    var previous = read(attributionKey);
    if (previous && Date.now() - previous.at < 30 * 60 * 1000) attribution = previous.values || {};
    if (query.has('utm_source')) {
      attribution = {};
      ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function (key) {
        var value = query.get(key);
        /* Keep only campaign labels. Never copy arbitrary URL data or oppref into GA4. */
        if (value && /^[a-zA-Z0-9_. -]{1,120}$/.test(value)) attribution[key] = value;
      });
      write(attributionKey, { at: Date.now(), values: attribution });
    }
  }
  function marker(id, vendor) { return 'zff_buyer_sent_' + vendor + '_' + id; }
  function alreadySent(id, vendor) { try { return sessionStorage.getItem(marker(id, vendor)) === '1'; } catch (e) { return true; } }
  function markSent(id, vendor) { try { sessionStorage.setItem(marker(id, vendor), '1'); return true; } catch (e) { return false; } }
  function drain() {
    loadPixel(); updateAttribution();
    if (pixelLoaded && !adsAllowed()) window.oaiq('consent', false);
    if (pixelLoaded && adsAllowed()) {
      window.oaiq('consent', true);
      if (isBuyerPage && !pageSent) {
        pageSent = true;
        window.oaiq('measure', 'page_viewed', { type: 'contents', contents: [{ id: program, content_type: 'page' }] }, { opt_out: true });
      }
    }
    if (!receipt) return;
    if (!gaSent && !alreadySent(receipt.id, 'ga4') && analyticsAllowed() && typeof window.gtag === 'function') {
      if (markSent(receipt.id, 'ga4')) {
        gaSent = true;
        window.gtag('event', receipt.eligible ? 'generate_lead' : 'zff_inquiry_submitted', {
          send_to: gaId, lead_source: 'website_buyer_form', program: receipt.program,
          organization_type: receipt.organization, store_count_bucket: receipt.stores,
          volume_basis: receipt.basis, event_id: receipt.id
        });
      }
    }
    if (receipt.eligible && !adSent && !alreadySent(receipt.id, 'openai') && adsAllowed() && pixelLoaded) {
      if (markSent(receipt.id, 'openai')) {
        adSent = true;
        window.oaiq('measure', 'lead_created', { type: 'customer_action' }, { event_id: receipt.id, opt_out: true });
      }
    }
  }
  function setupForm() {
    var form = document.getElementById('ZFFBuyerForm');
    if (!form) return;
    if (form.querySelector('[data-zff-inquiry-success]')) {
      var pending = read(pendingKey);
      if (pending && pending.path === pagePath && Date.now() - pending.at < 30 * 60 * 1000) receipt = pending;
      /* No pending valid submission means a direct thank-you visit cannot create a lead. */
      drain(); return;
    }
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      var organization = form.querySelector('#zff-organization-type').value;
      var stores = form.querySelector('#zff-stores').value;
      var volume = Number(form.querySelector('#zff-volume').value);
      var chain = (organization === 'chain' || organization === 'chain_distributor') && stores !== '1_2';
      var id = window.crypto && typeof window.crypto.randomUUID === 'function' ? window.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
      var pending = { id: id, at: Date.now(), path: pagePath, program: program, organization: organization,
        stores: stores, basis: form.querySelector('#zff-volume-basis').value,
        eligible: chain && (program !== 'private_label' || volume >= 300) };
      /* This receipt holds no name, company, email, phone, or free text. */
      if (analyticsAllowed() || adsAllowed()) write(pendingKey, pending);
      else { try { sessionStorage.removeItem(pendingKey); } catch (e) {} }
      form.querySelector('[data-zff-reference]').value = id;
      updateAttribution();
      form.querySelector('[data-zff-attribution]').value = Object.keys(attribution).map(function (key) { return key + '=' + attribution[key]; }).join('; ');
    });
  }
  function start() {
    setupForm(); drain();
    /* Existing Google channel and privacy API may load after theme assets. */
    var attempts = 0;
    var timer = window.setInterval(function () { drain(); if (++attempts >= 60) window.clearInterval(timer); }, 1000);
    document.addEventListener('visitorConsentCollected', drain);
    if (!privacy() && window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { drain(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
